module.exports = __webpack_public_path__ + "img/trash.35fda820.svg";